import {
    Button,
    Stack,
    TableCell,
    TableRow,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import { Company } from '@staffedupusa/shared-components';
import dayjs from 'dayjs';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateIcon from '@mui/icons-material/Create';
import PayrateEditModal from './PayrateEditModal';
import HoursWorkedEditModal from './HoursWorkedEditModal';
import DeleteRockerboxApplicatnt from './DeleteRockerboxApplicatnt';
import { useUpdatePayrate } from '../hooks/useUpdatePayrate';
import DownloadFormModal from './DownloadFormModal';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
type Applicant = {
    id: number;
    s_name: String;
};
type RowData = {
    email: String;
    hired: Date;
    pay_rate: String | null;
    hours_worked: String | null;
    wotc_credit: String | null;
    applicant: Applicant;
};
type RockerboxApplicantRowProps = {
    row: RowData;
};

const RockerboxApplicantRow: FC<RockerboxApplicantRowProps> = ({ row }) => {
    const [showPayrateEditModal, setShowPayrateEditModal] =
        useState<RowData | null>(null);
    const [showHoursWorkedEditModal, setShowHoursWorkedEditModal] =
        useState<RowData | null>(null);
    const [showDeleteModal, setShowDeleteModal] = useState<RowData | null>(null);
    const [showDownloadFormModal, setShowDownloadFormModal] =
        useState<RowData | null>(null);

    return (
        <>
            <TableRow>
                <TableCell>{row.applicant.id}</TableCell>
                <TableCell>{row.applicant.s_name}</TableCell>
                <TableCell>{dayjs(row.hired).format('MM/DD/YY')}</TableCell>
                <TableCell>
                    <Stack spacing={2} direction="row" alignItems="center">
                        <span>{row.pay_rate ? `$${row.pay_rate}` : 'N/A'}</span>
                        <Button
                            onClick={() => setShowPayrateEditModal(row)}
                            startIcon={<CreateIcon />}
                            size="small"
                            variant="contained"
                            sx={{ margin: '0 5px', alignSelf: 'flex-end', fontSize: '12px' }}
                        >
                            Edit
                        </Button>
                    </Stack>
                </TableCell>
                <TableCell>
                    <Stack spacing={2} direction="row" alignItems="center">
                        <span>{row.hours_worked}</span>
                        <Button
                            onClick={() => setShowHoursWorkedEditModal(row)}
                            startIcon={<CreateIcon />}
                            size="small"
                            variant="contained"
                            sx={{ margin: '0 5px', alignSelf: 'flex-end', fontSize: '12px' }}
                        >
                            Edit
                        </Button>
                    </Stack>
                </TableCell>
                <TableCell>{row.wotc_credit ? `${row.wotc_credit}` : 'N/A'}</TableCell>
                <TableCell>
                    <Button
                        variant="text"
                        size="small"
                        sx={{ fontSize: '14px' }}
                        onClick={() => setShowDownloadFormModal(row)}
                    >
                        Download Form
                    </Button>
                </TableCell>
                <TableCell>
                    <DeleteIcon
                        onClick={() => setShowDeleteModal(row)}
                        color="error"
                        sx={{ cursor: 'pointer' }}
                    />
                </TableCell>
            </TableRow>
            {showPayrateEditModal && (
                <PayrateEditModal
                    handleClose={() => setShowPayrateEditModal(null)}
                    item={showPayrateEditModal}
                />
            )}
            {showHoursWorkedEditModal && (
                <HoursWorkedEditModal
                    handleClose={() => setShowHoursWorkedEditModal(null)}
                    item={showHoursWorkedEditModal}
                />
            )}
            {showDeleteModal && (
                <DeleteRockerboxApplicatnt
                    handleClose={() => setShowDeleteModal(null)}
                    item={showDeleteModal}
                />
            )}
            {showDownloadFormModal && (
                <DownloadFormModal
                    handleClose={() => setShowDownloadFormModal(null)}
                    item={showDownloadFormModal}
                />
            )}
        </>
    );
};

export default RockerboxApplicantRow;
